import React from 'react';
import { Avatar } from 'antd';
import { GroupProps as GroupCopyProps } from 'antd/lib/avatar';

export type GroupProps = GroupCopyProps;

const ProAvatarGroup: React.FC<GroupProps> = (props) => {
  const { children, ...resProps } = props;
  return (
    <Avatar.Group { ...resProps }>{children}</Avatar.Group>
  );
}

export default ProAvatarGroup;